import { useCallback, useEffect, useState } from 'react'
import ApiService from '@services/api'

const field = (value, key) => value?.[key] ?? value?.[key.charAt(0).toUpperCase() + key.slice(1)]

export default function DeadlineRagIndexPanel() {
  const [coverage, setCoverage] = useState(null)
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')
  const [sourceKind, setSourceKind] = useState('')

  const refresh = useCallback(async () => {
    setBusy(true)
    setMessage('')
    try {
      const result = await ApiService.getDeadlineRagCoverage()
      if (!result.success) throw new Error(result.error || 'Não foi possível consultar a base.')
      setCoverage(result.data)
    } catch (error) {
      setMessage(error.message || 'Não foi possível consultar a base.')
      setCoverage(null)
    } finally {
      setBusy(false)
    }
  }, [])

  useEffect(() => { refresh() }, [refresh])

  const reindex = async () => {
    setBusy(true)
    setMessage('')
    try {
      const result = await ApiService.reindexDeadlineRagSources({ maximumSources: 10, sourceKind: sourceKind || null })
      if (!result.success) throw new Error(result.error || 'Não foi possível atualizar o índice.')
      const batch = result.data
      setCoverage(field(batch, 'coverage'))
      setMessage(`${field(batch, 'completedSources') ?? 0} fonte(s) indexada(s); ${field(batch, 'changedSourcesSkipped') ?? 0} ignorada(s) por alteração durante o processamento.`)
    } catch (error) {
      setMessage(error.message || 'Não foi possível atualizar o índice.')
    } finally {
      setBusy(false)
    }
  }

  const available = field(coverage, 'available') === true
  return (
    <div aria-busy={busy}>
      <p>Prepare as referências jurídicas e os exemplos de padrões antes de utilizá-los na revisão por IA. A contagem abaixo representa a cobertura do índice, e não a taxa de acerto dos padrões.</p>
      {coverage && available && (
        <dl className="deadline-task-grid">
          <div><dt>Fontes elegíveis</dt><dd>{field(coverage, 'eligibleSources')}</dd></div>
          <div><dt>Fontes indexadas</dt><dd>{field(coverage, 'indexedSources')}</dd></div>
          <div><dt>Fontes pendentes</dt><dd>{field(coverage, 'pendingSources')}</dd></div>
          <div><dt>Trechos indexados</dt><dd>{field(coverage, 'indexedChunks')}</dd></div>
        </dl>
      )}
      {coverage && !available && <p>A indexação está indisponível. Verifique a configuração do embedding e o armazenamento da base.</p>}
      <label className="rules-field">
        <span className="rules-field-label">Conteúdo do próximo lote</span>
        <select value={sourceKind} onChange={(event) => setSourceKind(event.target.value)} disabled={busy}>
          <option value="">Todas as fontes elegíveis</option>
          <option value="INDEPENDENT_LEGAL_SOURCE">Referências jurídicas</option>
          <option value="ACTION_PATTERN_EXAMPLE">Exemplos de padrões de ações</option>
        </select>
      </label>
      <div className="deadline-form-actions">
        <button type="button" className="btn btn-outline" disabled={busy} onClick={refresh}>Consultar cobertura</button>
        <button type="button" className="btn btn-primary" disabled={busy || !available || !field(coverage, 'pendingSources')} onClick={reindex}>
          {busy ? 'Processando…' : 'Indexar próximo lote'}
        </button>
      </div>
      <p className="rules-inline-note">Cada lote respeita o limite configurado no serviço, até 10 fontes, e utiliza o provedor de embeddings. Nenhuma aprovação ou regra do catálogo é alterada.</p>
      {message && <p role="status">{message}</p>}
    </div>
  )
}
